import { useTranslation } from 'react-i18next'

import { ComboBox } from '@reveni-io/reveni-ui'

import { billingTypes } from '../constants'

const TypeSelector = ({ onChange, value }) => {
  const { t } = useTranslation()

  const handleChange = e => {
    onChange(e.target.value === 'null' ? null : e.target.value)
  }

  return (
    <div>
      <ComboBox
        value={value || 'null'}
        label={t('Tipo factura')}
        fullWidth
        handleChange={handleChange}
        menuItems={billingTypes.map(type => ({ label: t(type.label), value: type.value }))}
      />
    </div>
  )
}

export default TypeSelector
